import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsEarningSimplerMocks: MicroMoments = {
  id: 'earning-simpler',
  actionId: 'earning-simpler-link',
  title: 'New SkyMiles Status Tracker Coming Soon',
  description:
    'Starting Jan. 1,2024, all SkyMiles Members earn toward their 2025 Medallion Status only through MQDs.',
  action: {
    label: 'Learn More',
    url: '/us/en/skymiles/medallion-program/2024-program-updates'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/nearly-status.gif',
    alt: 'EarningSimpler Logo image'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
